import { mmFetch } from '../mmFetch';

const fbmSmallsRetail = {
    downloadPackListReport: async (partnerOrderNumber, fbmAccountName) =>
        mmFetch(
            `api/fbm/smalls/v1/pack-list-report?partnerOrderNumber=${encodeURIComponent(partnerOrderNumber)}&fbmAccount=${fbmAccountName}`,
        ),
    downloadPalletLabels: async (partnerOrderNumber, fbmAccountName) =>
        mmFetch(
            `api/fbm/smalls/v1/palletLabels?partnerOrderNumber=${encodeURIComponent(partnerOrderNumber)}&fbmAccount=${fbmAccountName}`,
        ),
};

export { fbmSmallsRetail };
